import React from "react";
import { Table } from "rsuite";
import { Button } from "devextreme-react";

const { Cell } = Table;

export default function ActionButton({ rowData, ...props }) {
  return (
    <Cell {...props}>
      <Button
        type={props.type}
        text={props.text}
        className="text-button"
        onClick={() => props.handleEdit(rowData)}
        render={(btn) => (
          <div
            style={{
              padding: "7px 0px 0px 0px",
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <i className="material-icons">edit</i>
            <span>{btn.text}</span>
          </div>
        )}
      />
    </Cell>
  );
}
